export const appearanceTypes = {
  SUCCESS: 'success',
  DANGER: 'danger',
};
